module.exports = __webpack_public_path__ + "media/images/icons/pink-smile-e5beb91118b2a839b76fb9d8ca1add2f.svg";